import SwitcherButton from "../../../../../../../src/entities/UI/SwitcherButton/SwitcherButton";
import { SwitcherButtonStyle } from "../../../../../../../src/types/Interface";
import { EnumEventBus, eventBus } from "../../EventBus";


export default function addButton(
    label: string,
    onHandleFunc: () => void,
    onHandleSecondFunc: () => void,
    style: SwitcherButtonStyle,
    updateBg = true,
    isClosable = true
  ): SwitcherButton {
    const textSprite = SwitcherButton.generateText(label, style.fontSize || 28);
    const button = new SwitcherButton(style, textSprite, updateBg, onHandleFunc, onHandleSecondFunc);
    eventBus.on(EnumEventBus.newQuestion, () => isClosable ? button.closeButton() : "")
    return button
  }